<template>
  <ViewportBoundsListener />
  <login-register-modal
    @social-login-success="onSocialLoginSuccess"
  ></login-register-modal>
  <discount-modal></discount-modal>
  <phone-modal v-if="showPhoneModal"></phone-modal>
  <social-complete-registration-modal
    v-if="renderCompleteRegistrationModal"
    ref="socialCompleteRegistrationModalRef"
  ></social-complete-registration-modal>
  <cookie-consent>
    <slot name="cookie-consent"></slot>
  </cookie-consent>
</template>

<script lang="ts" setup>
import ViewportBoundsListener from "@/components/viewport-bounds-listener.vue";
import LoginRegisterModal from "@/features/user/login-register-modal.vue";
import SocialCompleteRegistrationModal from "@/features/user/social-login/social-complete-registration-modal.vue";
import PhoneModal from "@/features/profile/phone-modal.vue";
import DiscountModal from "@/features/discount/discount-modal.vue";
import CookieConsent from "@/features/cookie-consent/cookie-consent.vue";
import { ref } from "vue";

const socialCompleteRegistrationModalRef = ref();

const showPhoneModal = !!window.isHomePage;
const renderCompleteRegistrationModal = window.mangasPath !== "privacy";

const onSocialLoginSuccess = (payload: { action: "login" | "register" }) =>
  socialCompleteRegistrationModalRef.value?.handleSocialLoginSuccess(payload);
</script>
